import { css } from '@emotion/css';

import { BREAKPOINT_QUERIES } from '@lyearn/core/hooks/useScreen';
import { SIDEBAR_WIDTH } from '@/components/EditorBuilder/styles';

const SIDEBAR_MAX_WIDTH = 'calc(100% - 4.8rem)'; //mobile
const NEG_SIDEBAR_MAX_WIDTH = 'calc(4.8rem - 100%)'; //mobile

export const sidebarStyles = css`
  width: ${SIDEBAR_WIDTH}rem;
  max-width: ${SIDEBAR_MAX_WIDTH};
`;

export const mainContainerStyles = (
  showLeft: boolean,
  Left: React.ReactElement<any, string | React.JSXElementConstructor<any>> | null,
) => css`
  margin-inline-start: ${Left
    ? showLeft
      ? `0`
      : `max(${-SIDEBAR_WIDTH}rem, ${NEG_SIDEBAR_MAX_WIDTH})`
    : '0'};
  @media ${BREAKPOINT_QUERIES.Mobile} {
    min-width: 100vw;
    ${Left ? '' : 'margin-inline-start: 0;'}
  }
`;
